module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0039.png.f2c50497.jpg";